import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseAccordion = definePartsStyle({
  container: {
    border: "none",
    minHeight: "20px",
    padding: 0,

    _hover: {
      backgroundColor: "none",
    },
  },

  button: {
    backgroundColor: "#FFFFFF",
    border: "1px solid white",
    transition: "ease-out .2s",
    cursor: "pointer",
    borderRadius: "12px",
    mb: "8px",
    padding: "18px 24px",

    _hover: {
      borderColor: "darkPurple",
      backgroundColor: "white",
    },
  },

  panel: {
    padding: "0",
  },
});

export const accordionTheme = defineMultiStyleConfig({
  variants: {
    baseAccordion,
  },
});
